import * as React from 'react'

export const ExternalLinkIcon = React.memo(({
  className,
  ...props
}) => {
  return (
    <svg
      width='24'
      height='24'
      className={className}
      viewBox='0 0 24 24'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9.85263 1.5C10.4325 1.5 10.9026 1.95789 10.9026 2.52273C10.9026 3.04722 10.4973 3.4795 9.97508 3.53857L9.85263 3.54545H5.1V20.9318L18.75 21V13.5C18.75 12.9352 19.2201 12.4773 19.8 12.4773C20.3385 12.4773 20.7823 12.8721 20.8429 13.3807L20.85 13.5V21C20.85 22.0321 20.1429 22.9536 19.1259 23.039L18.9711 23.0455L4.87895 22.9773C3.83188 22.9773 3.07497 22.1049 3.00525 21.0857L3 20.9318V3.54545C3 2.51336 3.70706 1.59187 4.72411 1.50645L4.87895 1.5H9.85263ZM19.2199 2.90329L19.3232 2.96231L19.42 3.03062L19.4925 3.095C19.542 3.1433 19.5856 3.19522 19.6232 3.2499L19.7045 3.39136L19.7599 3.53751L19.7751 3.59937C19.7833 3.63285 19.7889 3.66562 19.7928 3.69854L19.7993 3.81873L19.8 8.93168C19.8001 9.49652 19.33 9.95447 18.7501 9.95455C18.2117 9.95455 17.7678 9.55986 17.7071 9.05123L17.7 8.93196L17.6985 6.2865L12.1425 11.7005C11.7324 12.0999 11.0676 12.0999 10.6575 11.7005C10.279 11.3318 10.2499 10.7517 10.5702 10.3504L10.6575 10.2541L16.215 4.8405L13.4999 4.84091C12.9614 4.84084 12.5176 4.44597 12.457 3.93732L12.45 3.81805C12.45 3.29355 12.8555 2.86133 13.3777 2.80232L13.5001 2.79545L18.7304 2.79563C18.8982 2.7926 19.0665 2.82849 19.2199 2.90329Z'
        fill='currentColor'
      />
    </svg>
  )
})

ExternalLinkIcon.displayName = 'ExternalLinkIcon'
